import { Flex } from "@mantine/core";
import BronzeStepCard from "./BronzeStepCard";
import MasterStepCard from "./MasterStepCard";
import PlatineStepCard from "./PlatineStepCard";

const StepCards: React.FC = () => {
  return (
    <Flex gap={20} className="flex-wrap items-stretch justify-center">
      <BronzeStepCard />
      <PlatineStepCard />
      <MasterStepCard />
    </Flex>
  );
};

export default StepCards;
